import { useContext, useState, useEffect, useRef } from 'react';
import { translateFault, generateUnhandledFault } from '../../helpers/faults';
import { WebApiContext } from 'ascendon-web-api';
import { getRetrieveEligibilityResponseUiModel } from '../../subscriptionInfo/components/upgradeSubscription/components/helpers/upgradeSubscriptionHelper';
import { subscriptionOptionsUrl } from '../../constants/checkout.constant';
import { readSessionId } from '../../utils/common';

function useRetrieveEligibility() {
  const [fault, setFault] = useState(null);
  const [uiModel, setUiModel] = useState('');
  const WebApi = useContext(WebApiContext);

  const isMounted = useRef(true);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const getApiParams = ({ staticApiUrl, staticApiKey, language }) => {
    const baseURL = `${staticApiUrl}`;
    const generalRequestHeaders = {
      name: 'Content-Type',
      value: 'application/json; charset=utf-8',
    };
    const setApiKey = staticApiKey?.length
      ? {
          add: [
            { name: 'apikey', value: staticApiKey },
            { name: 'CD-DeviceType', value: '4' },
            { name: 'CD-SessionId', value: readSessionId() },
            { name: 'locale', value: language?.split('-')?.[0] },
            { ...generalRequestHeaders },
          ],
        }
      : {
          add: [{ ...generalRequestHeaders }],
        };

    const headers = {
      ...setApiKey,
    };
    const staticApiSubscriptionOptionsUrl = `${baseURL}${subscriptionOptionsUrl}`;
    return {
      staticApiSubscriptionOptionsUrl,
      headers,
    };
  };

  const requestRetrieveEligibility = async ({
    staticApiUrl,
    staticApiKey,
    language,
  }) => {
    const { staticApiSubscriptionOptionsUrl, headers } = getApiParams({
      staticApiUrl,
      staticApiKey,
      language,
    });

    WebApi.subscriber({
      forceRefresh: true,
      method: 'GET',
      customUrl: staticApiSubscriptionOptionsUrl,
      headers,
    })
      .then((response) => {
        if (isMounted.current) {
          const retrieveEligibilityData = response.data;
          const retrieveEligibilityResponseUiModel =
            getRetrieveEligibilityResponseUiModel(retrieveEligibilityData);
          setUiModel(retrieveEligibilityResponseUiModel);
        }
      })
      .catch((error) => {
        console.warn({ error });
        if (isMounted.current) {
          const code = error?.data?.Code;
          let errorMsg;
          if (!code) {
            const unknownFault = generateUnhandledFault(error.data);
            errorMsg = translateFault(unknownFault).translatedMessage;
            setFault(errorMsg);
          } else {
            errorMsg = translateFault(error.data).translatedMessage;
            setFault(errorMsg);
          }
        }
      });
  };

  return [uiModel, fault, requestRetrieveEligibility];
}

export { useRetrieveEligibility };
export default useRetrieveEligibility;
